import React, { useState, useEffect, useContext } from "react";
import { Tab, Nav, Container, Form } from "react-bootstrap";
import SaveChanges from "./SaveChanges";
import updateParams from "utils/updateParams.js";
import OverallPPC from "./services/OverallPPC";
import Search from "./services/Search";
import Display from "./services/Display";
import Social from "./services/Social";
import Video from "./services/Video";

export const PacingContext = React.createContext();

export default function PpcPacing(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const [tabLocation, setTabLocation] = useState("overallPPC");

  const servicePicker = (searchParams) => {
    if (searchParams.toString().includes("paidSearch")) {
      return "paidSearch";
    }
    if (searchParams.toString().includes("daily")) {
      return "daily";
    }
    if (searchParams.toString().includes("display")) {
      return "social";
    }
    if (searchParams.toString().includes("display")) {
      return "video";
    }
  };

  const submitForm = () => {
    document.getElementById("ppc-pacing-data").submit();
  };

  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "overallPPC";
    }
    if (page === "paidSearch") {
      setTabLocation(page);
      updateParams("page", page);
      // updateParams("sub_page", servicePicker(searchParams));
    } else {
      setTabLocation(page);
      updateParams("page", page);
    }
  }, []);

  const selectTab = (key) => {
    if (key === "services") {
      setTabLocation(key);
      updateParams("page", key);
      // updateParams("sub_page", servicePicker(searchParams));
    } else {
      setTabLocation(key);
      updateParams("page", key);
    }
  };

  return (
    <div className="ppc-pacing-top ppc-pacing">
      <Form id="ppc-pacing-data" method="post" action="/datapulse/ppc-pacing">
        <input hidden name="authenticity_token" value={authenticityToken} readOnly />
        <input hidden name="client_account_id" value={props.selected_account} readOnly />
        <h1>PPC Pacing</h1>
        {props.ppc_pacing_metrics ? (
          <>
            <Tab.Container id="ppc-pacing-tabs" defaultActiveKey="overallPPC" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
              <Nav variant="pills" className="nav-fill tabs-navigation row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-5">
                <Nav.Item className="col">
                  <Nav.Link
                    eventKey="overallPPC"
                    className={`${props.enabled_services.ppc == false ? "disabled tab-titles sub-nav-item" : "tab-titles sub-nav-item"}`}
                    data-link-type="page">
                    <p className="">Overall PPC</p>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link
                    eventKey="paidSearch"
                    className={`${props.enabled_services.search == false ? "disabled tab-titles sub-nav-item" : "tab-titles sub-nav-item"}`}
                    data-link-type="page">
                    Paid Search
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link
                    eventKey="social"
                    data-link-type="page"
                    className={`${props.enabled_services.social == false ? "disabled tab-titles sub-nav-item" : "tab-titles sub-nav-item"}`}>
                    Social
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link
                    eventKey="display"
                    data-link-type="page"
                    className={`${props.enabled_services.display == false ? "disabled tab-titles sub-nav-item" : "tab-titles sub-nav-item"}`}>
                    Display
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link
                    eventKey="video"
                    data-link-type="page"
                    className={`${props.enabled_services.video == false ? "disabled tab-titles sub-nav-item" : "tab-titles sub-nav-item"}`}>
                    Video
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <PacingContext.Provider value={{ user: props.user, submitForm: submitForm }}>
                <Tab.Content>
                  <Tab.Pane eventKey="overallPPC">
                    {props.enabled_services.ppc == true ? (
                      <>
                        {Object.keys(props.ppc_pacing_metrics.overall).length != 0 ? (
                          <OverallPPC
                            service="overall"
                            metricsData={props.ppc_pacing_metrics ? props.ppc_pacing_metrics.overall : {}}
                            availableMetrics={props.available_metrics.overall}
                            servicePicker={servicePicker}
                            defaultMetrics={props.default_metrics[props.account_type]}
                            pacingOrder={props.pacing_order.overall ? props.pacing_order.overall : "default"}
                            dateRanges={props.date_ranges}
                            platforms={props.overall_platforms}
                            serviceEnabled={props.enabled_services.ppc}
                            frequency={props.frequency}
                          />
                        ) : (
                          <div className={"row service-disabled styled-indent-blue"}>
                            <div className="col-12 pt-1 pl-3">
                              <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                                <div className="standard-color-bg text-center py-4 px-1">
                                  <h5>This client doesn't have any PPC data.</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className={"row service-disabled styled-indent-blue"}>
                        <div className="col-12 pt-1 pl-3">
                          <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                            <div className="standard-color-bg text-center py-4 px-1">
                              <h5>This client doesn't have PPC enabled.</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="paidSearch">
                    {props.enabled_services.search == true ? (
                      <>
                        {Object.keys(props.ppc_pacing_metrics.search) != 0 ? (
                          <Search
                            service="search"
                            metricsData={props.ppc_pacing_metrics ? props.ppc_pacing_metrics.search : {}}
                            availableMetrics={props.available_metrics.search}
                            servicePicker={servicePicker}
                            defaultMetrics={props.default_metrics[props.account_type]}
                            pacingOrder={props.pacing_order.search ? props.pacing_order.search : "default"}
                            dateRanges={props.date_ranges}
                            platforms={props.search_platforms}
                            frequency={props.frequency}
                          />
                        ) : (
                          <div className={"row service-disabled styled-indent-blue"}>
                            <div className="col-12 pt-1 pl-3">
                              <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                                <div className="standard-color-bg text-center py-4 px-1">
                                  <h5>This client doesn't have any Search data.</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className={"row service-disabled styled-indent-blue"}>
                        <div className="col-12 pt-1 pl-3">
                          <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                            <div className="standard-color-bg text-center py-4 px-1">
                              <h5>This client doesn't have Search enabled.</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="social">
                    {props.enabled_services.social == true ? (
                      <>
                        {Object.keys(props.ppc_pacing_metrics.social) != 0 ? (
                          <Social
                            service="social"
                            metricsData={props.ppc_pacing_metrics ? props.ppc_pacing_metrics.social : {}}
                            availableMetrics={props.available_metrics.social}
                            servicePicker={servicePicker}
                            defaultMetrics={props.default_metrics[props.account_type]}
                            pacingOrder={props.pacing_order.social ? props.pacing_order.social : "default"}
                            dateRanges={props.date_ranges}
                            platforms={props.social_platforms}
                            frequency={props.frequency}
                          />
                        ) : (
                          <div className={"row service-disabled styled-indent-blue"}>
                            <div className="col-12 pt-1 pl-3">
                              <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                                <div className="standard-color-bg text-center py-4 px-1">
                                  <h5>This client doesn't have any Social data.</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className={"row service-disabled styled-indent-blue"}>
                        <div className="col-12 pt-1 pl-3">
                          <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                            <div className="standard-color-bg text-center py-4 px-1">
                              <h5>This client doesn't have Social enabled.</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="display">
                    {props.enabled_services.display == true ? (
                      <>
                        {Object.keys(props.ppc_pacing_metrics.display) != 0 ? (
                          <Display
                            service="display"
                            metricsData={props.ppc_pacing_metrics ? props.ppc_pacing_metrics.display : {}}
                            availableMetrics={props.available_metrics.display}
                            servicePicker={servicePicker}
                            defaultMetrics={props.default_metrics[props.account_type]}
                            pacingOrder={props.pacing_order.display ? props.pacing_order.display : "default"}
                            dateRanges={props.date_ranges}
                            platforms={props.display_platforms}
                            frequency={props.frequency}
                          />
                        ) : (
                          <div className={"row service-disabled styled-indent-blue"}>
                            <div className="col-12 pt-1 pl-3">
                              <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                                <div className="standard-color-bg text-center py-4 px-1">
                                  <h5>This client doesn't have any Display data.</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className={"row service-disabled styled-indent-blue"}>
                        <div className="col-12 pt-1 pl-3">
                          <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                            <div className="standard-color-bg text-center py-4 px-1">
                              <h5>This client doesn't have Display enabled.</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="video">
                    {props.enabled_services.video == true ? (
                       <>
                       {Object.keys(props.ppc_pacing_metrics.video) != 0 ? (
                          <Video
                            service="video"
                            metricsData={props.ppc_pacing_metrics ? props.ppc_pacing_metrics.video : {}}
                            availableMetrics={props.available_metrics.video}
                            servicePicker={servicePicker}
                            defaultMetrics={props.default_metrics[props.account_type]}
                            pacingOrder={props.pacing_order.video ? props.pacing_order.video : "default"}
                            dateRanges={props.date_ranges}
                            platforms={props.video_platforms}
                            frequency={props.frequency}
                          />
                        ) : (
                          <div className={"row service-disabled styled-indent-blue"}>
                            <div className="col-12 pt-1 pl-3">
                              <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                                <div className="standard-color-bg text-center py-4 px-1">
                                  <h5>This client doesn't have any Video data.</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className={"row service-disabled styled-indent-blue"}>
                        <div className="col-12 pt-1 pl-3">
                          <div className="no-gutters clear-both off-color-bg show py-4 px-5">
                            <div className="standard-color-bg text-center py-4 px-1">
                              <h5>This client doesn't have Video enabled.</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </PacingContext.Provider>
            </Tab.Container>
          </>
        ) : (
          <>
            <div className="standard-color-bg text-center py-4 px-1">
              <h5>This client doesn't have any PPC Data calculated yet.</h5>
            </div>
          </>
        )}
      </Form>
    </div>
  );
}
